"use client";

import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  src: string | null | undefined;
  alt: string;
  displayName: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function UserAvatar({ src, alt, displayName, size = "md", className = "" }: UserAvatarProps) {
  const sizeClasses = {
    sm: "h-10 w-10 text-xs",
    md: "h-20 w-20 sm:h-24 sm:w-24 text-2xl",
    lg: "h-32 w-32 text-3xl",
  };

  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase() || "?";

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      {src && (
        <AvatarImage 
          src={src} 
          alt={alt} 
          className="object-cover"
        />
      )}
      <AvatarFallback className="bg-muted font-semibold text-muted-foreground">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
